import { externalApiPathRegex } from '../external-api-path-regex';

const splitEndpoint = (endpoint: string) => {
  try {
    const { origin, pathname } = new URL(endpoint);

    return {
      origin,
      pathname,
    };
  } catch (error) {
    return {
      origin: '',
      pathname: endpoint,
    };
  }
};

export const getExternalApiEndpoint = (endpoint: string) => {
  const { origin, pathname } = splitEndpoint(endpoint);
  const match = externalApiPathRegex.exec(pathname);

  if (origin && !/\.wildberries\.ru$/.test(origin)) {
    return '';
  }

  if (match) {
    const [, externalApiPath] = match;

    return origin + externalApiPath;
  }

  return origin;
};
